import { render } from "./DesktopThemeToggle.vue?vue&type=template&id=1dfb46c0"
import script from "./DesktopThemeToggle.vue?vue&type=script&lang=js"
export * from "./DesktopThemeToggle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__